import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { LayoutComponent } from './layout/layout.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CategoryComponent } from './admin/menu/category/category.component';
import { AddcategoryComponent } from './admin/menu/category/addcategory/addcategory.component';
import { ImageuploadComponent } from './imageupload/imageupload.component';
import { BgFeatureduploadComponent } from './themeImages/bgfeaturedupload/bgfeaturedupload.component';
import { BgNewarrivaluploadComponent } from './themeImages/bgnewarrivalupload/bgnewarrivalupload.component';
import { ItemsComponent } from './admin/menu/items/items.component';
import { AdditemsComponent } from './admin/menu/items/additem/additem.component';
import { ModifiersComponent } from './admin/menu/modifiers/modifiers.component';
import { AddmodifierComponent } from './admin/menu/modifiers/addmodifier/addmodifier.component';
import { CustomersComponent } from './admin/customer/customers/customers.component';
import { AddcustomerComponent } from './admin/customer/customers/addcustomers/addcustomer.component';
import { LocationsComponent } from './admin/company/locations/locations.component';
import { AddlocationComponent } from './admin/company/locations/addlocation/addlocation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AddbrandComponent } from './admin/company/brands/addbrand/addbrand.component';

import { NgApexchartsModule } from 'ng-apexcharts';
import { ToastrModule } from 'ngx-toastr';
import { BrandComponent } from './admin/company/brands/brands.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SummaryComponent } from './admin/report/summary/summary.component';
import { NgbdDatepickerRangePopup } from './datepicker-range/datepicker-range-popup';
import { BannerComponent } from './admin/settings/banner/banner.component';
import { AddbannerComponent } from './admin/settings/banner/addbanner/addbanner.component';
import { SalesdetailComponent } from './admin/report/salesdetail/salesdetail.component';
import { SalesuserwiseComponent } from './admin/report/salesuserwise/salesuserwise.component';
import { SalescustomerwiseComponent } from './admin/report/salescustomerwise/salescustomerwise.component';
import { SalescategorywiseComponent } from './admin/report/salescategorywise/salescategorywise.component';
import { SalesitemwiseComponent } from './admin/report/salesitemwise/salesitemwise.component';
import { OffersComponent } from './admin/settings/offers/offers.component';
import { AddoffersComponent } from './admin/settings/offers/addoffers/addoffers.component';
import { OrdersComponent } from './admin/sales/orders/orders.component';
import { OrderdetailsComponent } from './admin/sales/orderdetails/orderdetails.component';
import { SubcategoryComponent } from './admin/menu/subcategory/subcategory.component';
import { AddsubcategoryComponent } from './admin/menu/subcategory/addsubcategory/addsubcategory.component';
import { GiftComponent } from './admin/menu/gift/gift.component';
import { AddgiftComponent } from './admin/menu/gift/addgift/addgift.component';
import { GeneralsettingsComponent } from './admin/settings/generalsettings/generalsettings.component';
import { CouponComponent } from './admin/settings/coupon/coupon.component';
import { AddcouponComponent } from './admin/settings/coupon/addcoupon/addcoupon.component';
import { ExcelService } from 'src/ExportExcel/excel.service';
import { NotificationsComponent } from './admin/settings/notifications/notifications.component';
import { AddnotificationsComponent } from './admin/settings/notifications/addnotifications/addnotifications.component';
import { ReviewsComponent } from './admin/settings/reviews/reviews.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { EditorderComponent } from './admin/sales/editorder/editorder.component';
import { NgbdDatepickerPopup } from './datepicker-popup/datepicker-popup';
import { DeliveryComponent } from './admin/settings/delivery/delivery.component';
import { AdddeliveryComponent } from './admin/settings/delivery/adddelivery/adddelivery.component';
import { CityComponent } from './admin/menu/city/city.component';
import { AddcityComponent } from './admin/menu/city/addcity/addcity.component';
import { DynamicCssComponent } from './admin/settings/dynamiccss/dynamiccss.component';
import { BgNewsletteruploadComponent } from './themeImages/bgnewsletterupload/bgnewsletterupload.component';
import { BgPopularuploadComponent } from './themeImages/bgpopularupload/bgpopularupload.component';
import { BgTestimonialuploadComponent } from './themeImages/bgtestimonialupload/bgtestimonialupload.component';
import { BgWorkflowuploadComponent } from './themeImages/bgworkflowupload/bgworkflowupload.component';
import { logouploadComponent } from './themeImages/logoupload/logoupload.component';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    DashboardComponent,
    LayoutComponent,
    CounterComponent,
    LoginComponent,
    FetchDataComponent,
    CategoryComponent,
    AddcategoryComponent,
    ItemsComponent,
    AdditemsComponent,
    ModifiersComponent,
    AddmodifierComponent,
    CustomersComponent,
    AddcustomerComponent,
    BrandComponent,
    AddbrandComponent,
    LocationsComponent,
    AddlocationComponent,
    ImageuploadComponent,
    BgFeatureduploadComponent,
    BgNewarrivaluploadComponent,
    BgNewsletteruploadComponent,
    BgPopularuploadComponent,
    BgTestimonialuploadComponent,
    BgWorkflowuploadComponent,
    logouploadComponent,
    SummaryComponent,
    NgbdDatepickerRangePopup,
    NgbdDatepickerPopup,
    BannerComponent,
    AddbannerComponent,
    OffersComponent,
    AddoffersComponent,
    SalesdetailComponent,
    SalescategorywiseComponent,
    SalescustomerwiseComponent,
    SalesitemwiseComponent,
    SalesuserwiseComponent,
    OrdersComponent,
    OrderdetailsComponent,
    SubcategoryComponent,
    AddsubcategoryComponent,
    GiftComponent,
    AddgiftComponent,
    GeneralsettingsComponent,
    CouponComponent,
    AddcouponComponent,
    NotificationsComponent,
    AddnotificationsComponent,
    ReviewsComponent,
    EditorderComponent,
    DeliveryComponent,
    AdddeliveryComponent,
    CityComponent,
    AddcityComponent,
    DynamicCssComponent

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    NgSelectModule,
    NgxUiLoaderModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    NgApexchartsModule,
    RouterModule.forRoot([
      { path: '', component: LoginComponent, pathMatch: 'full' },
      {
        path: 'admin', component: LayoutComponent,
        children: [
          { path: 'dashboard', component: DashboardComponent },
          { path: 'category', component: CategoryComponent },
          { path: 'category/add', component: AddcategoryComponent },
          { path: 'category/edit/:id', component: AddcategoryComponent },

          { path: 'subcategory', component: SubcategoryComponent },
          { path: 'subcategory/add', component: AddsubcategoryComponent },
          { path: 'subcategory/edit/:id', component: AddsubcategoryComponent },

          { path: 'city', component: CityComponent },
          { path: 'city/add', component: AddcityComponent },
          { path: 'city/edit/:id', component: AddcityComponent },

          { path: 'gift', component: GiftComponent },
          { path: 'gift/add', component: AddgiftComponent },
          { path: 'gift/edit/:id', component: AddgiftComponent },

          { path: 'item', component: ItemsComponent },
          { path: 'item/add', component: AdditemsComponent },
          { path: 'item/edit/:id', component: AdditemsComponent },

          { path: 'modifier', component: ModifiersComponent },
          { path: 'modifier/add', component: AddmodifierComponent },
          { path: 'modifier/edit/:id', component: AddmodifierComponent },

          { path: 'orders', component: OrdersComponent },
          { path: 'orders/add', component: OrderdetailsComponent },
          { path: 'orders/view/:id', component: OrderdetailsComponent },
          { path: 'orders/edit/:id', component: EditorderComponent },

          { path: 'customer', component: CustomersComponent },
          { path: 'customer/add', component: AddcustomerComponent },
          { path: 'customer/edit/:id', component: AddcustomerComponent },

          { path: 'location', component: LocationsComponent },
          { path: 'location/add', component: AddlocationComponent },
          { path: 'location/edit/:id', component: AddlocationComponent },

          { path: 'brand', component: BrandComponent },
          { path: 'brand/add', component: AddbrandComponent },
          { path: 'brand/edit/:id', component: AddbrandComponent },

          { path: 'banner', component: BannerComponent },
          { path: 'banner/add', component: AddbannerComponent },
          { path: 'banner/edit/:id', component: AddbannerComponent },

          { path: 'offers', component: OffersComponent },
          { path: 'offers/add', component: AddoffersComponent },
          { path: 'offers/edit/:id', component: AddoffersComponent },

          { path: 'notifications', component: NotificationsComponent },
          { path: 'notifications/add', component: AddnotificationsComponent },
          { path: 'notifications/edit/:id', component: AddnotificationsComponent},

          { path: 'reviews', component: ReviewsComponent },

          { path: 'coupon', component:CouponComponent },
          { path: 'coupon/add', component: AddcouponComponent },
          { path: 'coupon/edit/:id', component: AddcouponComponent },

          { path: 'settings', component: GeneralsettingsComponent },
          { path: 'dynamiccss', component: DynamicCssComponent },

          { path: 'report/summary', component: SummaryComponent },
          { path: 'report/salesdetail', component: SalesdetailComponent },
          { path: 'report/salesuserwise', component: SalesuserwiseComponent },
          { path: 'report/salescustomerwise', component: SalescustomerwiseComponent },
          { path: 'report/salescategorywise', component: SalescategorywiseComponent },
          { path: 'report/salesitemwise', component: SalesitemwiseComponent },

          { path: 'delivery', component: DeliveryComponent },
          { path: 'delivery/add', component: AdddeliveryComponent },
          { path: 'delivery/edit/:id', component: AdddeliveryComponent },
        ]
      }
    ]),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgbModule
  ],
  providers: [],
  exports: [NgbdDatepickerRangePopup,NgbdDatepickerPopup],
  bootstrap: [AppComponent, NgbdDatepickerRangePopup,NgbdDatepickerPopup]
})
export class AppModule { }
